var render = function render(_c, _vm) {
  return _c("p", { staticClass: "size-sm muted icon-search-powered-by" }, [
    _c("span", { staticClass: "sr-only" }, [_vm._v("This icon search is ")]),
    _vm._v(" "),
    _c("span", { staticClass: "text-capitalize" }, [_vm._v("powered")]),
    _vm._v("\n  by\n  "),
    _c(
      "a",
      {
        staticClass: "no-underline secondary margin-left-4xs",
        attrs: {
          href: "https://www.algolia.com/developers/?utm_source=fontawesome&utm_medium=referral",
          target: "_blank",
        },
        on: {
          click: function ($event) {
            return _vm.parent.$posthog.capture(
              "referral:powered_by_algolia_link_click",
              { context: "icon_search_view" }
            )
          },
        },
      },
      [
        _c("font-awesome-icon", {
          attrs: { icon: _vm.parent.$v6.brands.faAlgolia, size: "lg" },
        }),
        _vm._v("\n    Algolia\n  "),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }